module.exports = __webpack_public_path__ + "static/media/mc_tooltip_polygon.64826369.svg";